// Pure helpers for the native paywall copy. Prices come from StoreKit when available; a free
// period is promised only when Apple (isEligibleForIntroOffer) confirms it for this Apple Account.
// Apple's introductory offer is separate from Molaroo's own app trial.

export function introPeriodText(p) {
  if (!p?.introPeriodValue || !p?.introPeriodUnit) return null;
  return `${p.introPeriodValue}-${p.introPeriodUnit}`;
}

export function introPeriodPhrase(p) {
  if (!introPeriodText(p)) return null;
  const v = p.introPeriodValue;
  return `${v} ${p.introPeriodUnit}${v === 1 ? "" : "s"}`;
}

export function hasFreeTrialOffer(p) {
  return !!(p && p.introEligible === true && p.introPaymentMode === "freeTrial" && introPeriodText(p));
}

// "AUD $14.99" when StoreKit reports the currency code, else Apple's localized display price.
export function storeKitPrice(p) {
  if (!p?.displayPrice) return null;
  return p.currencyCode ? `${p.currencyCode} ${p.displayPrice}` : p.displayPrice;
}

export function nativeCtaLabel(p) {
  if (hasFreeTrialOffer(p)) return `Try free for ${introPeriodPhrase(p)}`;
  if (p?.displayPrice) return `Subscribe — ${p.displayPrice}/month`;
  return "Subscribe";
}

export function nativePriceLine(p, fallbackPrice) {
  const price = storeKitPrice(p) || fallbackPrice;
  if (hasFreeTrialOffer(p)) return `Free for ${introPeriodPhrase(p)} (Apple introductory offer), then ${price} / month.`;
  return `${price} / month.`;
}

// Headline price: StoreKit first, backend plan price as fallback.
export function nativeMainPrice(p, fallbackAmount, fallbackCurrency) {
  if (p?.displayPrice) return { amount: p.displayPrice, currency: p.currencyCode || "" };
  return { amount: `$${fallbackAmount}`, currency: fallbackCurrency };
}
